/* PhotoLightbox — full-screen image viewer with pinch-zoom (native), tap to close.
   Used across ORIO wherever a user-generated image should be expandable
   (missions, stories thumbnails, chat attachments, dog photos, etc.).
*/
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function PhotoLightbox({ src, alt = "", onClose }) {
  // ESC closes; body scroll locked while open.
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[3200] flex items-center justify-center bg-black/95 backdrop-blur-sm"
      onClick={onClose}
      data-testid="photo-lightbox"
    >
      <button
        onClick={onClose}
        aria-label="Chiudi"
        data-testid="lightbox-close"
        className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white/20"
      >
        <X className="h-5 w-5" />
      </button>
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="max-h-[92vh] max-w-[96vw] object-contain touch-pinch-zoom select-none"
        style={{ touchAction: "pinch-zoom" }}
      />
    </div>,
    document.body,
  );
}
